export const GET_DATA = 'getDataC';
export const LOADING = 'loadingC';
export const ERROR = 'errorC';
export const CREATEDIRECTORY = 'createC';
export const SELECTING = 'selectingC';